/**
 * The ท่าใหญ่ of the arts without an own table (A6 skeleton, speed mode): each picks a shape template (templates.ts) that fits its identity
 * and overrides length, tell, radius, power, blow count, reach and rhythm so no two are alike. The held foe gains rage
 * (LONG_ULT.rageToFoe). TODO-polish: names kept from the skill data; poses / FX / sfx are the template's generic keys until
 * each art's motion / FX / sound lanes give its own (queue section P).
 */
import { buildUlt, type UltShape } from './templates';
import { registerLongMove } from './registry';

const S = (
  skillId: string,
  name: string,
  template: UltShape['template'],
  len: number,
  tell: number,
  radius: number,
  power: number,
  blows: number,
  reach: number,
  warp: number,
): UltShape => ({ skillId, name, template, len, tell, radius, power, blows, reach, warp });

export const ALL_ULTS: readonly UltShape[] = [
  // rooted pull + barrage: palms, grips, locks, seals
  S('cp-heaven', 'ฝ่ามือเมฆาครอบฟ้า', 'rooted', 4.6, 0.8, 3.0, 3.8, 1.25, 1, 1.0),
  S('ts-heaven', 'วงธาราผนึกฟ้า', 'rooted', 4.8, 0.9, 3.4, 3.6, 0.75, 1, 0.92),
  S('ar-buddha', 'ฝ่ามือศิลาพันบันได', 'rooted', 4.2, 0.7, 2.8, 4.0, 1.5, 0.85, 1.12),
  S('pp-tathagata', 'ฝ่ามือระฆังครอบฟ้า', 'rooted', 4.4, 0.8, 3.2, 3.9, 1.0, 1.0, 1.06),
  S('ah-imperial', 'หัตถ์มังกรราชันย์', 'rooted', 4.0, 0.7, 2.6, 3.7, 0.5, 0.9, 0.85),
  S('sf-divine', 'อักษรปราณสะท้านฟ้า', 'rooted', 4.9, 0.9, 3.6, 3.5, 1.75, 1, 0.97),
  S('jl-abyss', 'ฝ่ามือมารนรก', 'rooted', 4.3, 0.75, 3.0, 4.1, 1.12, 1.0, 1.18),
  // dash passes + vortex: swift blades and shadows
  S('ss-hatred', 'เหมันต์สะกดธาร', 'dash', 4.7, 0.7, 3.2, 3.8, 1.0, 1.0, 1.0),
  // ms-eclipse: its own table now (moonSword.ts, kit audit piece 7)
  S('jz-scroll', 'ม้วนคัมภีร์สะท้านฟ้า', 'dash', 4.9, 0.7, 3.0, 3.6, 1.25, 0.9, 0.93),
  S('dd-heaven', 'เงาจันทร์ร่ายรำ', 'dash', 4.1, 0.7, 3.6, 3.9, 1.5, 1.2, 1.15),
  // leap + slam: heavy blades and claws
  S('ns-heaven', 'ศิลาตื่นสะท้านฟ้า', 'leap', 4.8, 0.9, 3.4, 4.2, 1.0, 1.1, 1.0),
  S('jy-dragon', 'ดาบมังกรผ่าฟ้า', 'leap', 4.5, 0.8, 3.0, 4.0, 1.0, 1.0, 1.05),
  S('bs-massacre', 'โลหิตคลั่งกระหายเลือด', 'leap', 4.2, 0.7, 3.2, 4.1, 1.5, 0.9, 0.9),
  S('sp-decree', 'ดาบอัสนีราชโองการ', 'leap', 4.6, 0.8, 3.6, 3.8, 0.75, 1.2, 1.12),
  S('bc-tiger', 'พยัคฆ์โลหิตขย้ำฟ้า', 'leap', 4.0, 0.7, 2.8, 3.9, 2.0, 0.8, 0.88),
  S('fm-vanquish', 'พันพุทธะพิชิตมาร', 'leap', 4.9, 0.9, 3.0, 3.7, 1.25, 1.0, 1.2),
  S('dp9-sky', 'มังกรทองเก้าสวรรค์', 'leap', 4.4, 0.75, 3.8, 4.2, 1.0, 1.25, 0.96),
  // spin field: storms and staffs
  // rc-sea: its own table now (redCliffSabre.ts, kit audit piece 10: a push march, off bs-massacre's spin + lifesteal)
  S('dp-eighteen', 'ฝ่ามือมังกรพายุสะท้านฟ้า', 'spin', 4.3, 0.7, 3.2, 4.0, 1.5, 1, 0.9),
  S('tt-tide', 'คลื่นไผ่ท่วมฟ้า', 'spin', 5.0, 0.9, 4.0, 3.5, 1.0, 1.1, 1.1),
  // throw rain: hidden weapons, ink and characters thrown
  S('hw-stars', 'หมื่นดาราสังหาร', 'throw', 4.5, 0.7, 3.8, 3.9, 1.5, 1, 1.0),
  S('sg-masterpiece', 'ภาพปราชญ์สะท้านแผ่นดิน', 'throw', 4.8, 0.8, 3.4, 3.6, 1.0, 1.1, 0.94),
];

export const ULTS = ALL_ULTS.map((s) => registerLongMove(buildUlt(s)));
